<template>
    <div :id="scene._id">
        <img
            :id="scene._id"
            :src="scene.stage.elements[0].asset.src"
            :style="imgStyle"
            @click="onClick"
            @dblclick="onDblClick"
        />
        <svg viewBox="0 0 100 100" height="28" width="28" style="user-select: none;">
            <title>{{ playersInThisScenePreview }}</title>
            <circle cx="50" cy="36" r="36" fill="black" />
            <path d="M 0 100 L 18 74 L 26 68 H 74 L 82 74 L 100 100 Z" fill="black" />
            <text fill="white" x="50" y="85" font-size="70" text-anchor="middle">
                {{ playersInThisScene.length }}
            </text>
        </svg>
        <Button @click="onMoveAll">Move all</Button>
    </div>
</template>

<script lang="ts">
import { mapState } from 'vuex';

export default {
    props: {
        scene: {
            type: Object,
            default: function() {
                return {
                    _id: 'default',
                    stage: {
                        elements: [
                            {
                                asset: { kind: 'image', src: '/static/assets/marc.png' },
                            },
                        ],
                    },
                };
            },
        },
    },
    data: function() {
        return {
            selected: false,
        };
    },
    computed: {
        ...mapState('collections', {
            players: 'players',
        }),
        imgStyle: function() {
            return {
                width: '95%',
                height: '50px',
                border: this.selected ? '2px dotted' : '',
                'object-fit': 'cover',
            };
        },
        playersInThisScene: function() {
            if (!this.players) {
                return [];
            }
            return Object.values(this.players).filter(p => p['sceneId'] === this.scene._id);
        },
        playersInThisScenePreview: function() {
            const players = this.playersInThisScene;
            return Object.values(players)
                .map(p => p['userId'])
                .join('\n');
        },
    },
    methods: {
        onClick: function() {
            this.$emit('onSelect', { scene: this.$props.scene, component: this });
        },
        onDblClick: function() {
            this.$emit('onEdit', { scene: this.$props.scene });
        },
        onMoveAll: function() {
            this.$emit('onMoveAll', { scene: this.$props.scene });
        },
    },
};
</script>

<style>
.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 60px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>
